import { usePathname, useRouter } from "next/navigation";
import { useEffect, useContext, useState } from "react";
import { useLocale } from "next-intl";

import { LanguageContext } from "@/app/providers";
import { getProfile } from "@/services/profile.service";
import useProfileStore from "@/store/useProfileStore";
import { useQuery } from "@tanstack/react-query";

const useHeader = () => {
  const [open, setOpen] = useState<boolean>(false);
  const router = useRouter();
  const locale = useLocale();
  const { switchLanguage } = useContext(LanguageContext);
  const { setProfile } = useProfileStore();
  const pathname = usePathname();
  const pathTitle = pathname.split("/")[1];

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      const response = await getProfile();
      setProfile(response);
      return response;
    },
  });

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  const runCommand = (route: string) => {
    setOpen(false);
    router.push(route);
  };

  return {
    open,
    setOpen,
    pathTitle,
    profile,
    runCommand,
    switchLanguage,
    locale,
  };
};

export default useHeader;
